import styles from "./toolbox-components.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useRef, useEffect } from "react";

interface ToolboxComponentInputProps {
  text: string;
  placeholder?: string;
  onChangeText: (text: string) => void;
  className?: string;
  autoFocusOnMount?: boolean;
  variant?: "outlined" | "minimal";
  disabled?: boolean;
  secure?: boolean;
  lineNumber?: number | null;
}

export const ToolboxComponentInput = ({
  text,
  placeholder,
  onChangeText,
  className,
  autoFocusOnMount,
  variant = "outlined",
  disabled = false,
  secure = false,
  lineNumber = null,
}: ToolboxComponentInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (autoFocusOnMount) {
      if (inputRef.current) {
        inputRef.current.focus();
      } else if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }
  }, [autoFocusOnMount]);

  const isMultiline = lineNumber !== null && lineNumber > 1;

  if (isMultiline) {
    return (
      <textarea
        ref={textareaRef}
        className={filterClasses(
          styles.textarea,
          className,
          variant === "outlined" ? styles.textareaOutlined : styles.textareaMinimal,
          disabled ? styles.disabled : ""
        )}
        placeholder={placeholder}
        value={text}
        onChange={(e) => onChangeText(e.target.value)}
        disabled={disabled}
        rows={lineNumber || undefined}
      />
    );
  }

  return (
    <input
      ref={inputRef}
      className={filterClasses(
        styles.input,
        className,
        variant === "outlined" ? styles.inputOutlined : styles.inputMinimal,
        disabled ? styles.disabled : ""
      )}
      type={secure ? "password" : "text"}
      placeholder={placeholder}
      value={text}
      onChange={(e) => onChangeText(e.target.value)}
      disabled={disabled}
    />
  );
};
